import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { ICustomerRelationship } from "@smartrr/shared/entities/CustomerRelationship";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { localize, typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React, { useCallback, useEffect } from "react";
import { toast } from "react-toastify";

import { useCloseModal } from "@customer-app/state/actionCreators/modal";
import { sendPaymentUpdateEmail } from "@customer-app/state/actionCreators/payment";
import {
  useSmartrrCustomerDispatch,
  useSmartrrCustomerSelector,
} from "@smartrr/customer-portal/src/_state/typedCustomerReduxHooks";

import { CenterText } from "./CenterText";

interface IEditPaymentViewProps {
  purchaseState: IPurchaseState;
  customerRelationship: ICustomerRelationship | any;
}

export const EditPaymentView = ({ purchaseState, customerRelationship }: IEditPaymentViewProps): JSX.Element => {
  const localizeShorthand = "subscriptions.yourSubscriptions.manageSubscriptionModal.editPaymentView";
  const dispatch = useSmartrrCustomerDispatch();
  const closeModal = useCloseModal();
  const liquidCustomer = useSmartrrCustomerSelector(state => state.auth.liquidCustomer);

  const onPaymentMethodRequestChange = useCallback(async () => {
    if (!customerRelationship || !purchaseState.pmtMth?.id) {
      return;
    }

    await dispatch(sendPaymentUpdateEmail(customerRelationship, purchaseState.pmtMth?.id));

    toast(localize(`${localizeShorthand}.sentToast`));
  }, [customerRelationship, purchaseState]);

  useEffect(() => {
    onPaymentMethodRequestChange();
  }, []);

  return (
    <React.Fragment>
      <CenterText title={localize(`${localizeShorthand}.title`)}>
        {localize(`${localizeShorthand}.body1`)}
        <br />
        <span style={{ fontWeight: 700 }}>{liquidCustomer?.email}</span>
        <br />
        {localize(`${localizeShorthand}.body2`)}
      </CenterText>
      <hr />
      <AquariusButton onClick={() => closeModal()}>{typedLocalize("general.backToAccountBtn")}</AquariusButton>
    </React.Fragment>
  );
};
